import React from "react";
import { Box, Container, SimpleGrid, Text, useColorModeValue } from "@chakra-ui/react";
import { TiltCard } from "../../common/TiltCard";
import { usePublicGlassSurface } from "../../common/publicVisual";

const QUOTES = [
  {
    quote: "Fewer tabs. I finally keep chores and rent splits beside my actual todos.",
    by: "Early user · India",
  },
  {
    quote: "Portfolio + voice saves me rewriting the same rupee totals for clients.",
    by: "Freelancer · beta tester",
  },
];

export default function TestimonialStrip() {
  const glass = usePublicGlassSurface();
  const quoteClr = useColorModeValue("gray.700", "gray.100");
  const byClr = useColorModeValue("gray.500", "gray.400");

  return (
    <Box as="section" py={{ base: 10, md: 14 }} bg="transparent">
      <Container maxW="container.xl" px={{ base: 4, md: 6 }}>
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={{ base: 5, lg: 8 }}>
          {QUOTES.map((q) => (
            <TiltCard
              key={q.quote}
              tilt={8}
              p={6}
              borderRadius="2xl"
              borderWidth="1px"
              sx={{ transformStyle: "preserve-3d" }}
              {...glass}
            >
              <Text
                fontSize="md"
                fontStyle="italic"
                color={quoteClr}
                lineHeight="tall"
                mb={4}
                sx={{ transform: "translateZ(12px)" }}
              >
                “{q.quote}”
              </Text>
              <Text fontSize="xs" color={byClr} fontWeight="semibold">
                {q.by}
              </Text>
            </TiltCard>
          ))}
        </SimpleGrid>
      </Container>
    </Box>
  );
}
